<template>
    <div class="app">
    <!-- Logo dinámico -->
    <img
      :src="standInfo.logo || '/AgroSQ.png'"
      class="logo-principal"
      :alt="standInfo.name || 'Pulso Agrícola'"
      @error="ev => ev.target.src = '/AgroSQ.png'"
    />
    <!-- Nombre del stand -->
    <div class="stand-nombre" v-if="standInfo.name">{{ standInfo.name }}</div>

    <!-- Login -->
    <div v-if="!token" class="login-container">
      <h2>Login</h2>
      <input v-model="loginData.username" placeholder="Usuario" />
      <input v-model="loginData.password" type="password" placeholder="Contraseña" />
      <button @click="login">Entrar</button>
      <div v-if="loginError" class="error">{{ loginError }}</div>
      <div class="footer-login">
    © {{ new Date().getFullYear() }} Pulso Agrícola | Todos los derechos reservados
  </div>

    </div>

    <div v-else>
      <div class="navbar">
        <b>Bienvenido, {{ user.role }}</b>
        <span v-if="user.role === 'stand' && standInfo.name">| Stand: {{ standInfo.name }}</span>
        <button v-if="user.role === 'superadmin'" @click="panel = 'stands'">Stands</button>
        <button v-if="user.role === 'superadmin'" @click="panel = 'users'">Usuarios</button>
        <button v-if="user.role === 'superadmin'" @click="panel = 'asistentes'">Asistentes</button>
        <button v-if="user.role === 'superadmin'" class="logout-btn" @click="logout">Salir</button>
      </div>
      <!-- Paneles -->
      <StandsPanel
        v-if="panel === 'stands' && user.role === 'superadmin'"
        :token="token"
        @regresar="panel = 'asistentes'"
        @stand-update="fetchStandInfo"
      />
      <UsersPanel
        v-if="panel === 'users' && user.role === 'superadmin'"
        :token="token"
        @regresar="panel = 'asistentes'"
      />
      <AdminPanel
        v-if="panel === 'asistentes' && user.role !== 'superadmin'"
        :token="token"
        :role="user.role"
        :stand_id="user.stand_id"
        :intereses="standInfo.interests && standInfo.interests.length ? standInfo.interests : defaultIntereses"
        @logout="logout"
        @salir="logout"
      />
      <!-- Si superadmin: solo muestra la tabla general (sin formulario) -->
      <SuperAdminTable
        v-if="panel === 'asistentes' && user.role === 'superadmin'"
        :token="token"
      />
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import AdminPanel from './AdminPanel.vue'
import StandsPanel from './StandsPanel.vue'
import UsersPanel from './UsersPanel.vue'
import SuperAdminTable from './SuperAdminTable.vue'


export default {
  components: { AdminPanel, StandsPanel, UsersPanel, SuperAdminTable },
  data() {
    return {
      loginData: { username: '', password: '' },
      loginError: '',
      token: localStorage.getItem('expo-token') || '',
      user: { role: '', stand_id: null },
      panel: 'asistentes',
      standInfo: { name: '', logo: '', interests: [] },
      defaultIntereses: ["Pippap", "Coolers", "Seguridad", "Otro"]
    }
  },
  async created() {
    if (this.token) await this.afterLogin()
  },
  methods: {
    async login() {
      this.loginError = ''
      try {
        const res = await axios.post('/api/login', this.loginData)
        this.token = res.data.token
        localStorage.setItem('expo-token', this.token)
        await this.afterLogin()
      } catch {
        this.loginError = 'Usuario o contraseña incorrectos'
      }
    },
    async afterLogin() {
      await this.fetchUser()
      await this.fetchStandInfo()
    },
    async fetchUser() {
      const res = await axios.get('/api/me', { headers: { Authorization: 'Bearer ' + this.token } })
      this.user = res.data
    },
    async fetchStandInfo() {
      if (this.user.stand_id) {
        const res = await axios.get('/api/stand/info', {
          headers: { Authorization: 'Bearer ' + this.token }
        })
        // Siempre intenta parsear los intereses personalizados primero
        let interests = res.data.interests
        if (!Array.isArray(interests) || !interests.length) interests = this.defaultIntereses
        this.standInfo = {
          ...res.data,
          interests
        }
      } else {
        this.standInfo = {
          name: 'Pulso Agrícola',
          logo: '/AgroSQ.png',
          interests: this.defaultIntereses
        }
      }
    },
    logout() {
      localStorage.removeItem('expo-token')
      this.token = ''
      this.user = { role: '', stand_id: null }
      this.panel = 'asistentes'
      this.standInfo = { name: '', logo: '', interests: [] }
    }
  }
}
</script>

<style>
.app {
  max-width: 390px;
  margin: auto;
  padding: 16px;
  font-family: Arial, sans-serif;
}
.logo-principal {
  display: block;
  max-width: 230px;
  width: 92%;
  margin: 24px auto 10px auto;
}
.stand-nombre {
  text-align: center;
  font-weight: bold;
  color: #246813;
  font-size: 1.18em;
  margin-bottom: 8px;
}
.login-container {
  background: #f9f9f9;
  border-radius: 8px;
  padding: 22px 12px;
  box-shadow: 0 2px 8px #0001;
  margin-top: 40px;
}
input, button, select, textarea {
  display: block;
  width: 100%;
  margin-bottom: 12px;
  padding: 10px;
  border-radius: 5px;
  border: 1px solid #ddd;
  font-size: 1em;
  box-sizing: border-box;
}
button {
  background: #0078d4;
  color: white;
  border: none;
  font-weight: bold;
  cursor: pointer;
  margin-bottom: 2px;
}
button.logout-btn {
  background: #e43d3d;
  margin-top: 8px;
}
.navbar {
  margin-bottom: 18px;
  display: flex;
  gap: 7px;
  align-items: center;
  flex-wrap: wrap;
  font-size: 1em;
}
.error { color: #e43d3d; font-weight: bold; margin-bottom: 12px; }
@media (max-width: 600px) {
  .app { padding: 6px; }
  .logo-principal { max-width: 170px; }
  .login-container { padding: 8px; }
  .navbar { font-size: .99em; }
}
.footer-login {
  margin-top: 18px;
  text-align: center;
  font-size: 0.85em;
  color: #666;
}




</style>
